import { qualificationConfig } from 'src/redux/slices/QualificationConfig/Type'

/**
 * @description Returns true if the qualification include benefits
 * @param applicationState
 * @returnsboolean
 */
export const includeBenefits = (qualification?: qualificationConfig): boolean => {
  if (qualification && qualification.revenue_ratio_include_benefits) {
    return true
  }

  return false
}
